import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "view-result-card-component" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "background-linear" }, null, -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "px-3 cares-info open-sans-font" }, " Nossa farmacêutica tem uma orientação importante para você. Confira: ", -1)
const _hoisted_5 = {
  key: 0,
  class: "iframe-container mb-24"
}
const _hoisted_6 = { class: "iframe-wrapper" }
const _hoisted_7 = { class: "iframe-position" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "col-12 px-3"
}
const _hoisted_10 = { class: "card" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "col-12 px-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, "O que fazer agora?", -1)
const _hoisted_14 = { class: "subtitle-text" }
const _hoisted_15 = { class: "col-12 px-3 mb-16" }
const _hoisted_16 = {
  key: 2,
  class: "col-12 px-3 mb-16"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle-text" }, " Gostaria de repetir o teste acompanhado de um profissional de saúde? ")
], -1)
const _hoisted_18 = { class: "col-12 px-3" }
const _hoisted_19 = { class: "col-12 px-3 mt-32" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle-text text-center" }, " Se ainda tiver dúvidas, entre em contato: ", -1)
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center\"><p class=\"title-text mg-0\">SAC Chembio Gratuito</p><p class=\"subtitle-text-black\">0800-887-1589</p><p class=\"subtitle-text-black\">24horas/todos os dias</p></div><div class=\"text-center\"><p class=\"title-text mg-0\">Ministério da Saúde</p><p class=\"subtitle-text-black\">Disque saúde 136</p></div>", 2)
const _hoisted_23 = [
  _hoisted_21
]
const _hoisted_24 = { class: "footer" }
const _hoisted_25 = { class: "legal-info open-sans-font" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Este resultado é relativo a declaração registrada pelo próprio paciente que realizou o teste. O autoteste não configura um exame laboratorial e esse cartão de resultado não tem valor legal e nem de laudo oficial. ")
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "powered-container" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "Powered By", -1)
const _hoisted_30 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_view_result_card_header = _resolveComponent("view-result-card-header")!
  const _component_info_slider_component = _resolveComponent("info-slider-component")!
  const _component_online_appointment = _resolveComponent("online-appointment")!
  const _component_ButtonExternalLink = _resolveComponent("ButtonExternalLink")!
  const _component_result_card_modal = _resolveComponent("result-card-modal")!
  const _component_warning_test_modal = _resolveComponent("warning-test-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_view_result_card_header, {
        "user-name": _ctx.patient.name || 'Autoteste HIV-1/2 Sure Check'
      }, null, 8, ["user-name"]),
      _createVNode(_component_info_slider_component, {
        "result-infos": _ctx.resultInfos,
        onOpenResultCard: _ctx.openResultCard
      }, null, 8, ["result-infos", "onOpenResultCard"]),
      _createVNode(_component_online_appointment, { link: "https://clinicarx.conectamedico.com.br/" }),
      _hoisted_4,
      (this.iframePlayer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("iframe", {
                  src: _ctx.resultInfos.urlVideo,
                  width: "100%",
                  height: "200",
                  mozallowfullscreen: "",
                  webkitallowfullscreen: "",
                  frameborder: "0",
                  allow: "autoplay; fullscreen",
                  allowfullscreen: ""
                }, "\n            ", 8, _hoisted_8)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.resultInfos.info)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", {
                class: "card-msg",
                innerHTML: _ctx.resultInfos.info
              }, null, 8, _hoisted_11)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.resultInfos.whatDoNext), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_ButtonExternalLink, {
          label: "Buscar atendimento no SUS",
          link: "http://cnes2.datasus.gov.br/Mod_Ind_Especialidades_Listar.asp?VTipo=106&VListar=1&VEstado=00&VMun=00&VComp=00&VTerc=00&VServico=106&VClassificacao=001&VAmbu=&VAmbuSUS=&VHosp=&VHospSus=/"
        })
      ]),
      (_ctx.resultInvalid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_ButtonExternalLink, {
              label: "Comprar teste com sigilo",
              link: "https://shop.chembio.com.br/"
            })
          ]))
        : _createCommentVNode("", true),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_ButtonExternalLink, {
          label: "Encontrar uma farmácia",
          link: "https://saude.clinicarx.com.br/servicos-clinicos/exame-hiv-teste/"
        })
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", {
          class: "card",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stopVideo && _ctx.stopVideo(...args)))
        }, _hoisted_23)
      ]),
      _createVNode(_component_result_card_modal, {
        id: "card-result-modal",
        ref: "result-modal"
      }, null, 512),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          (_ctx.patient.age <= 12)
            ? (_openBlock(), _createElementBlock("span", _hoisted_27, " Autoteste realizado para menor de 12 anos. O usuário declara que o teste foi realizado com supervisão ou ajuda do adulto responsável."))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("img", { src: _ctx.logoClinicarxPath }, null, 8, _hoisted_30)
        ])
      ])
    ]),
    _createVNode(_component_warning_test_modal, { ref: "warning-test-modal" }, null, 512)
  ]))
}